import script from "./OcrVerificationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./OcrVerificationForm.vue?vue&type=script&setup=true&lang=ts"

import "./OcrVerificationForm.vue?vue&type=style&index=0&id=7fa6ac64&lang=scss"
import "./OcrVerificationForm.vue?vue&type=style&index=1&id=7fa6ac64&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fa6ac64"]])

export default __exports__